import React from 'react'
import DocumentationSidebar from '../component/DocumentationSidebar';
import Searchbar from '../component/SearchBar';
import image001 from '../assetes/images/settings/teams-img/image001.png';
import image002 from '../assetes/images/settings/teams-img/image002.png';
import image003 from '../assetes/images/settings/teams-img/image003.png';
import image004 from '../assetes/images/settings/teams-img/image004.png';
import image005 from '../assetes/images/settings/teams-img/image005.png';
import image006 from '../assetes/images/settings/teams-img/image006.png';
import image007 from '../assetes/images/settings/teams-img/image007.png';
import image008 from '../assetes/images/settings/teams-img/image008.png';

export default function Teams() {
    return (
        <>
            <div className='d-flex flex-column main-outer-wrapper'>
                <div className="flex-grow-1 d-flex survey-main-wrapper">
                    <DocumentationSidebar />

                    {/* Dashboard Content */}
                    <div className="flex-grow-1 dashboard-page-outer">
                        <div className='dashboard-page-wrap document-page-wrap'>
                            <Searchbar containerSelector=".search-scope" />
                            <div className='search-scope mt-4'>
                                <h1 className='mt-0 text-primary'>Teams</h1>
                                <p className='header-para mb-10'>
                                    Teams are a way to organize groups of users within an organization. Each team
                                    can have its own unique name and consists of assigned roles for each user. It is
                                    possible for different teams to have the same user with different roles, and
                                    multiple teams may have the same name. In this case all permissions are merge
                                    for that name. </p>
                                <p className='header-para mb-10'>
                                    Teams are only visible to users who have created or are part of a specific team.
                                    The team creator has the ability to manage team members by adding, editing, or
                                    deleting them. However, they cannot remove or delete their own name from the
                                    team. </p>

                                <p className='header-para'>  Teams provide a structured approach to collaboration and allow users to work
                                    together on specific projects or tasks. They help streamline communication,
                                    assign responsibilities, and facilitate efficient teamwork.
                                </p>

                                <div className="card dashboard-card mb-4">
                                    <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                        Accessing Account Settings and filter
                                    </div>
                                    <div className="card-body">
                                        <p>  Navigating to the Team  Section: </p>
                                        <ul>
                                            <img src={image001} alt="fullview" className='img-fluid pt-10 pb-20' />
                                            <li>Go to the Settings menu on the left sidebar.</li>
                                            <li>Under the User management section, select Teams (highlighted in red in the image).</li>
                                            <li>This section allows you to manage all Teams in your organization.</li>
                                        </ul>
                                        <p> <b> Searching for a Teams: </b></p>
                                        <ul>
                                            <img src={image002} alt="searchbar" className='img-fluid pt-10 pb-20' />
                                            <li>Use the Search bar at the top to find a specific team by name.</li>
                                            <li>The list will dynamically update as you type.</li>
                                        </ul>

                                        {/* <p> <b> sort by filter: </b></p>
                                    <ul>
                                        <img src={image003} alt="filter" className='pt-10 pb-20' />
                                        <li>sort by filter available for easy
                                            access to data</li>
                                       <li>Tt will have two options for sorting alphabetically accentind (A-Z) or decending (Z-A) order</li>
                                    </ul> */}
                                    </div>
                                </div>

                                <div className="card dashboard-card mb-4">
                                    <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                        Teams List Overview
                                    </div>
                                    <div className="card-body">
                                        <p>The team list displays the following columns:</p>
                                        <ul>
                                            <img src={image004} alt="table" className='img-fluid pt-20 pb-20' />
                                            <li>Team name - Displays Serial number </li>
                                            <li>Member  - Displays the Role name (e.g., Admin, Viewer, Editor).</li>
                                            <li>Actions - Provides options to edit or delete  the team. <br />
                                            </li>
                                        </ul>

                                        <p> <b>Editing a team - </b> The Edit Team interface allows administrators to modify an existing team by updating its name, adding new members with specific roles, and managing existing team members.</p>

                                        <ul>
                                            <img src={image005} alt="Edit" className='w-90 pt-10 pb-20' />
                                            <li>Click the Edit (Pencil) icon under the Action column.
                                            </li>
                                            <li> <b> Team Name </b>- Input Field: Displays the current team name.Allows users to edit and update the team’s name.
                                                <ul className='pt-10'>
                                                    <li>Save & Cancel Buttons (Team Name)</li>
                                                    <li>Save: Saves the updated team name.</li>
                                                    <li>Cancel: Discards any changes made to the team name.</li>
                                                </ul>
                                            </li>
                                            <li> <b>Additional Options:</b>
                                                <ul className='pt-10 pb-10'>
                                                    <li><b>Add users (top right): </b>  Opens an option to include more members into the team. <br />
                                                        <img src={image008} alt="Add users Add users " className='pt-20 pb-20' />
                                                        <ul>
                                                            <li>Add member (Dropdown) -  likely pulled from a list of existing users</li>
                                                            <li>Select role (Dropdown) - choose role from Role name (e.g., Admin, Viewer, Editor).</li>
                                                            <li>Select country (Dropdown) - select country from dropdown</li>

                                                        </ul>
                                                    </li>
                                                    <li><b>Team name field:</b> Editable text input where you can update the name of the team.</li>
                                                    <li><b>Save Button:</b> Confirms and adds the selected member with the assigned role.</li>
                                                </ul>
                                            </li>

                                            This interface is essential for team management, role assignment, and user access control within the system.
                                        </ul>

                                        <p> <b>Deleting a User</b> </p>
                                        <ul>
                                            <img src={image006} alt="Delete" className='pt-10 pb-20' />
                                            <li>Click the Delete (Trash) icon under the Action column.
                                            </li>
                                            <li>A confirmation popup will appear.
                                            </li>
                                            <li>Click Confirm to permanently remove the user.</li>
                                        </ul>

                                        <p> <b>Manage Members (Arrow Icon)</b> </p>
                                        <ul>

                                            <li>Opens the team’s member management interface, enabling the addition or removal of members.
                                            </li>

                                        </ul>

                                    </div>
                                </div>

                                <div className="card dashboard-card mb-4">
                                    <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                        Add New Role
                                    </div>
                                    <div className="card-body">

                                        <ul>

                                            <li>Click the + Create Role button (red button on the top right).</li>
                                            <li>user redireded to add team page  </li>
                                            <li>when enter team name and then save will create new team</li>
                                            <img src={image007} alt="Form" className='pt-20 pb-20' />


                                        </ul>

                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

